module.exports = __webpack_public_path__ + "img/vertical_7_4_8019.9d17437a.png";